import { get, post, put, deleteRequest } from './_defaults/fetch.js';

// Get all ideas for a conversation
export const getIdeas = async ({ conversationId, config } = {}) =>
    get(`/agents/company-mapping/conversations/${conversationId}/ideas`, config);

// Create a new idea
export const createIdea = async ({ conversationId, body, config }) =>
    post(`/agents/company-mapping/conversations/${conversationId}/ideas`, body, config);

// Update an existing idea
export const updateIdea = async ({ id, body, config }) =>
    put(`/agents/company-mapping/ideas/${id}`, body, config);

// Delete an idea
export const deleteIdea = async ({ id, config }) =>
    deleteRequest(`/agents/company-mapping/ideas/${id}`, null, config);

// Conversation APIs
export const getConversations = async ({ params, config } = {}) =>
    get('/agents/company-mapping/conversations', { params, ...config });

export const createConversation = async ({ body, config }) =>
    post('/agents/company-mapping/conversations', body, config);

export const chat = async ({ conversationId, body, config }) =>
    post(`/agents/company-mapping/conversations/${conversationId}/chat`, body, config);

// Share conversation (send export link via email)
export const shareConversation = async ({ conversationId, body, config }) =>
    post(`/agents/company-mapping/conversations/${conversationId}/share`, body, config);